import {
  CC_ESTIMATE_SAVE_REQUEST,
  CC_ESTIMATE_SAVE_SUCCESS,
  CC_ESTIMATE_SAVE_FAILED,
  CC_ESTIMATE_LOAD_REQUEST,
  CC_ESTIMATE_LOAD_SUCCESS,
  CC_ESTIMATE_LOAD_FAILED,
  CC_ESTIMATE_STATE_CHANGE,
} from "../../../_utils/constants/CountertopCabinetEstimate";

const initialState = {
  estimate: null, // last loaded/saved estimate response
  isSaving: false,
  isSaved: false,
  isLoading: false,
  isLoaded: false,
  errors: {},
};

const CountertopCabinetEstimateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CC_ESTIMATE_SAVE_REQUEST:
      return { ...state, isSaving: true, isSaved: false, errors: {} };
    case CC_ESTIMATE_SAVE_SUCCESS:
      return { ...state, isSaving: false, isSaved: true, estimate: action.payload, errors: {} };
    case CC_ESTIMATE_SAVE_FAILED:
      return { ...state, isSaving: false, isSaved: false, errors: action.payload || {} };

    case CC_ESTIMATE_LOAD_REQUEST:
      return { ...state, isLoading: true, isLoaded: false, errors: {} };
    case CC_ESTIMATE_LOAD_SUCCESS:
      return { ...state, isLoading: false, isLoaded: true, estimate: action.payload, errors: {} };
    case CC_ESTIMATE_LOAD_FAILED:
      return { ...state, isLoading: false, isLoaded: false, errors: action.payload || {} };

    case CC_ESTIMATE_STATE_CHANGE:
      return { ...state, [action.key]: action.value };

    default:
      return state;
  }
};

export default CountertopCabinetEstimateReducer;
